import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";
import { supabase } from "@/integrations/supabase/client";
import logo from "@/assets/skillswipe-logo.png";
import SEO from "@/components/SEO";

const Splash = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    // Redirect based on auth and onboarding status
    if (!loading && user) {
      checkOnboardingStatus(user.id);
    }
  }, [user, loading, navigate]);

  const checkOnboardingStatus = async (userId: string) => {
    const { data, error } = await supabase
      .from('profiles')
      .select('gender, location')
      .eq('id', userId)
      .single();

    if (!error && data) {
      // Check if user has completed onboarding
      if (!data.gender || !data.location) {
        navigate("/onboarding", { replace: true });
      } else {
        navigate("/swipe", { replace: true });
      }
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <>
      <SEO 
        title="SkillSwipe - Learn Skills Together"
        description="Connect with peers who share your passion for learning. Teach what you know, learn what you want, and grow together through skill exchange."
        canonical="https://skillswipe.co.in"
      />
      <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6 gap-8">
      {/* Content */}
      <div className="flex flex-col items-center justify-center text-center space-y-6">
        <img 
          src={logo} 
          alt="SkillSwipe Logo" 
          width={256}
          height={134}
          fetchPriority="high"
          className="w-64 h-auto object-contain mix-blend-multiply dark:mix-blend-screen"
        />
        
        <div className="space-y-3">
          <p className="text-lg md:text-xl text-muted-foreground max-w-md">
            Swipe. Learn. Grow. Earn.
          </p>
          
          <p className="text-sm text-muted-foreground max-w-sm">
            You teach me, I teach you. Trade skills with a swipe.
          </p>
        </div>
      </div>

      {/* Bottom Button */}
      <div className="w-full max-w-md">
        <Button
          variant="gradient"
          size="lg"
          className="w-full"
          onClick={() => navigate("/swipe")}
        >
          Enter to Explore
        </Button>
      </div>
      </div>
    </>
  );
};

export default Splash;
